import OrderDetailsConfig from '../table/configs/order-request-details.json';
import {ActionCompletionDialogComponent} from '../common/action-completion-dialog/action-completion-dialog.component';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {CommonService} from '../services/common.service';
import {Component, OnInit} from '@angular/core';
import {ConfirmActionDialogComponent} from '../common/confirm-action-dialog/confirm-action-dialog.component';
import {ConfirmationDialogComponent} from '../repair-details/confirmation-dialog/confirmation-dialog.component';
import {CreateLoadingRequestComponent} from '../common/create-loading-request/create-loading-request.component';
import {CreateUnloadingRequestComponent} from '../common/create-unloading-request/create-unloading-request.component';
import {LoadingService} from '../services/loading.service';
import {MatDialog} from '@angular/material';
import {MaterialAccessoriesDialogComponent} from './material-accessories-dialog/material-accessories-dialog.component';
import {PurchaseOrdersService} from '../services/purchase-orders.service';
import {ToastMessagesService} from '../services/toast-messages.service';

@Component({
  styleUrls: ['./request-order-details.component.scss'],
  templateUrl: './request-order-details.component.html'
})
export class RequestOrderDetailsComponent implements OnInit {
  public orderDetailsConfig: any;
  public requestDetails: any;
  public basicDetailsConfig: any;
  public showBasicInfo: boolean;
  public isCustomerCodeFieldEditable: boolean;
  public isLoading: boolean;
  public customerCode: any;
  private user: any;
  public canCancelRequest: any;
  public statusId: number;

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              private commonService: CommonService,
              private loadingService: LoadingService,
              private matDialog: MatDialog,
              private purchaseOrdersService: PurchaseOrdersService,
              private router: Router,
              private toastMessagesService: ToastMessagesService) {
    this.requestDetails = JSON.parse(localStorage.getItem('requestDetails'));
    this.showBasicInfo = false;
    this.initUser();
    this.statusId = -1;
    this.isLoading = false;
    this.isCustomerCodeFieldEditable = false;
  }


  private async initUser() {
    this.user = await this.authService.getUser();
    this.statusId = await this.purchaseOrdersService.fetchStatusId(`request/web/status?id=${this.requestDetails.requestId}`);
    this.customerCode = await this.commonService.getSimpleList(`sale_point/${this.requestDetails.sale_point_id}/customer_code`);
    await this.initBasicInfo();
  }

  public async ngOnInit(): Promise<any> {
    this.activatedRoute.params.subscribe(params => {
      this.orderDetailsConfig = JSON.parse(JSON.stringify(OrderDetailsConfig));
      this.orderDetailsConfig.filter = `request_id=${params.id}`;

      if (this.requestDetails.type_id === 6) {
        const columns = this.orderDetailsConfig.columns;
        columns.splice(5, 0, {
          name: 'passed_new',
          title: 'Εγκεκριμένα νέα από Επιθεωρητή',
          type: 'text'
        });

        columns.splice(6, 0, {
          name: 'passed_used',
          title: 'Εγκεκριμένα μεταχειρισμένα από Επιθεωρητή',
          type: 'text'
        });
        columns.push({
          name: 'sales_inspector_action_description',
          title: 'Ενέργεια Επιθεωρητή',
          type: 'text'
        });
      }
    });
    this.canCancelRequest = await this.purchaseOrdersService.checkIfCanCancelRequest(this.requestDetails.requestId);

  }

  private async initBasicInfo() {
    this.showBasicInfo = true,
      this.basicDetailsConfig = {
        showActions: await this.commonService.showActions(this.user),
        subtitle: [
          {
            title: 'Αριθμός αίτησης',
            value: this.requestDetails.requestId
          }
        ],
        title: 'Πληροφορίες Αίτησης'
      };

    this.initializeActions();
  }

  private async initializeActions() {
    const actions = [];
    const action = {
      function: () => {
        this.initializeCreateLoadingRequest(2);
      },
      showAction: this.ShowLoadingAction(),
      title: 'Δημιουργία εντολής φόρτωσης',
      icon: 'cloud_upload',
      color: 'green'
    };
    actions.push(action);
    const action2 = {
      function: () => {
        this.initializeCreateUnloadingOrderDialog(2);
      },
      showAction: this.ShowReceiveAction(),
      title: 'Δημιουργία Εντολής Παραλαβής',
      icon: 'cloud_download',
      color: '#266ccd'
    };

    actions.push(action2);

    const action3 = {
      function: () => {
        this.initializeConfirmCancellationDialog(this.requestDetails);
      },
      showAction: this.requestDetails.status_id === 5 || this.requestDetails.status_id === 6,
      title: 'Aκύρωση Αίτησης',
      icon: 'cancel',
      color: 'red'
    };
    // actions.push(action3);
    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = await this.commonService.showActions(this.user);
    } else {
      this.basicDetailsConfig.showActions = false;
    }
  }

  private async initializeConfirmCancellationDialog(details) {
    const cancellationDialog = this.matDialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Είστε σίγουροι ότι θέλετε να ακυρώσετε την εντολή διαφημιστικού υλικού με αριθμό ${details.requestId}?`,
        title: 'Ακύρωση Εντολής Διαφημιστικού Υλικού'
      }
    });

    cancellationDialog.afterClosed().subscribe(async (response) => {
      if (response) {
        await this.cancelEntireRequest(details);
      }
    });
  }

  private async cancelEntireRequest(details) {
    try {
      await this.commonService.deleteItem(`request/web`, details.requestId);
      this.toastMessagesService.toastMessages('Η ακύρωση ολοκληρώθηκε με επιτυχία');
      await this.router.navigate(['purchase_order_requests']);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  public async confirmCancellation() {
    this.matDialog.open(ConfirmActionDialogComponent, {
      data: {
        confirmFunction: () => {
          this.cancelRequest({id: this.requestDetails.requestId});
        },
        message: `Είστε σίγουροι ότι θέλετε να ακυρώσετε την αίτηση με αριθμό ${this.requestDetails.requestId}?`,
        title: 'Ακύρωση Αίτησης'
      }
    });
  }

  public canCancelRequestOrder() {
    return ((this.statusId === 5 || this.statusId === 6 || this.statusId === 1)
      || (this.statusId === 7 && this.canCancelRequest === 0)) && this.user && this.user.role_alternate_name !== 'hqManager';
  }

  public async cancelRequest(object: any) {
    try {
      await this.purchaseOrdersService.updateReceiptCommand('request/web', object);
      this.matDialog.open(ActionCompletionDialogComponent, {
        data: {
          buttonText: 'Πλοήγηση στις αιτήσεις',
          redirectURL: `purchase_order_requests`
        }
      });
    } catch (e) {
    }
  }

  private async initializeCreateLoadingRequest(type: number) {
    this.loadingService.show();
    const users = await this.commonService.getListWithParameters('user', 'role_id=2 OR role_id = 13 OR role_id = 14');
    const details = await this.commonService.getListWithParameters('request/web/details', `request_id=${this.requestDetails.requestId}`);
    this.loadingService.hide();
    const dialog = this.matDialog.open(CreateLoadingRequestComponent, {
      data: {
        users,
        details,
        order_id: this.requestDetails.requestId,
        type,
        purchaseDocument: null,
        type_id: this.requestDetails.type_id
      }
    });
    dialog.afterClosed().subscribe( async response => {
      if (response && response.result) {
        await this.commonService.insertObject( 'loading_command/accessories', {id: response.result});
        await this.commonService.updateObject( 'request/update_after_loading_command', {id: this.requestDetails.requestId});
      }
    });
  }

  private async initializeCreateUnloadingOrderDialog(type: number) {
    // this.loadingService.show();
    const users = await this.commonService.getListWithParameters('user', 'role_id=2 OR role_id=13 OR role_id=14');
    const details = await this.commonService.getListWithParameters('request/web/details', `request_id=${this.requestDetails.requestId}`);
    const roles = await this.commonService.getListWithParameters('role', 'id=6 OR id=13 OR id=14');
    this.loadingService.hide();
    this.matDialog.open(CreateUnloadingRequestComponent, {
      data: {
        orderType: 1,
        roles,
        users,
        details,
        type,
        order_id: this.requestDetails.requestId,
        purchaseDocument: null
      }
    });
  }

  private ShowReceiveAction(): boolean {
    const canShow = (this.statusId === 6 || this.statusId === 7) &&
      this.requestDetails.type_id === 5 && this.user.role_alternate_name !== 'hqManager';
    return canShow;
  }

  private ShowLoadingAction() {
    const canShow = (this.statusId === 6 || this.statusId === 7 || this.statusId === 15) &&
      this.requestDetails.type_id !== 7 && this.user.role_alternate_name !== 'hqManager' && this.customerCode;
    return canShow;
  }

  public showCustomerCodeField() {
    return this.user && (this.user.role_alternate_name === 'basicUser' || this.user.role_alternate_name === 'transportManager');
  }

  public async updateSalePointCustomerCode() {
    try {
      this.isLoading = true;
      const object = {
        salePointID: this.requestDetails.sale_point_id,
        customerCode: this.customerCode
      };
      const data = await this.commonService.updateObject('sale_point/customer_code', object);
      if (data) {
        this.matDialog.open(ActionCompletionDialogComponent, {
          data: {
            buttonText: '',
            redirectURL: ''
          }
        });
      }
    } catch (e) {
      this.isLoading = false;
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isLoading = false;
      this.isCustomerCodeFieldEditable = false;
    }
  }

  openAccessories() {
      this.matDialog.open(MaterialAccessoriesDialogComponent, {
        data: {
          requestID: this.requestDetails.requestId
        }
      });
    }
  }

